import type {
  FolderAsset,
  Project,
  Workspace,
} from '@frameio/graphql-client/generated';
import { useGetResourceQuery } from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '@frameio/shared/contexts';
import { useGetDirectMemberships } from './useGetDirectMemberships';
import { useGetResourcesGrantingAccess } from './useGetResourcesGrantingAccess';

type UsePreloadAccessInfoProps = {
  fetchData?: boolean;
  projectId?: Project['id'];
  resourceId?: FolderAsset['id'] | Project['id'] | Workspace['id'];
};

export function usePreloadAccessInfo({
  fetchData,
  resourceId,
}: UsePreloadAccessInfoProps) {
  const accountId = useActiveAccountId();
  const { data: resourceData } = useGetResourceQuery({
    variables: {
      accountId: accountId ?? '',
      id: resourceId,
    },
    skip: !fetchData || !resourceId || !accountId,
  });

  const resourceTypename = resourceData?.account?.resource?.__typename;

  useGetResourcesGrantingAccess({
    fetchData: fetchData && resourceTypename && resourceTypename !== 'Account',
    id: resourceId,
  });

  useGetDirectMemberships({
    fetchData,
    resourceId,
  });
}
